"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderHtml = exports.Html = exports.default = void 0;
var Html_1 = require("./Html");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(Html_1).default; } });
Object.defineProperty(exports, "Html", { enumerable: true, get: function () { return __importDefault(Html_1).default; } });
var render_1 = require("./render");
Object.defineProperty(exports, "renderHtml", { enumerable: true, get: function () { return __importDefault(render_1).default; } });
//# sourceMappingURL=index.js.map